const PREFETCH_URLS = [
  '/assets/video/demo.mp4',
];

export const VIDEO_CACHE_NAME = 'dca-videos-v1';

export function registerVideoCache() {
  if (typeof window === 'undefined') return;

  if (navigator.storage?.persist) {
    navigator.storage.persist().catch(() => {});
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/video-cache-sw.js').catch(() => {});
      scheduleWarmCache();
    });
    return;
  }

  scheduleWarmCache();
}

export async function persistPlayedVideo(url) {
  if (!url || !('caches' in window)) return;

  try {
    const cache = await caches.open(VIDEO_CACHE_NAME);
    if (await cache.match(url)) return;

    const response = await fetch(url, { cache: 'force-cache' });
    if (response.ok) {
      await cache.put(url, response);
    }
  } catch (error) {
    // 非安全上下文或配额不足时忽略
  }
}

function scheduleWarmCache() {
  const warm = () => {
    warmVideoCache().catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(warm, { timeout: 12000 });
    return;
  }

  setTimeout(warm, 8000);
}

async function warmVideoCache() {
  if (!('caches' in window)) return;

  const cache = await caches.open(VIDEO_CACHE_NAME);
  for (const url of PREFETCH_URLS) {
    const hit = await cache.match(url);
    if (hit) continue;
    try {
      await cache.add(url);
    } catch (error) {
      // 配额不足或网络失败时跳过，不影响页面播放
    }
  }
}
